<div class="card p-4">
  <div class="card-content">
    <h3>We are having trouble logging you in.</h3>
    <p>
      Please try logging in one more time or request support so we can assist
      you.
    </p>
    <div class="card-buttons">
      <button
        id="retry-login-button"
        nf-button="primary"
        [routerLink]="homepage"
        (click)="clearStorage()"
      >
        <span class="mdi mdi-arrow-left"></span> Retry Login
      </button>
      <a
        nf-button="primary"
        href="https://jira.arbfund.com/CreateIssue.jspa?issuetype=28&pid=24900"
        target="_blank"
        class="ml-3"
      >
        Request Support
      </a>
    </div>
  </div>
</div>
